export default __webpack_public_path__ + "static/media/lineaKoncept.66dad4bf.jpg";